import React from "react";

const steps = [
    { t: "Define a market", d: "Enter a location and one or more business types." },
    { t: "Run the search", d: "Review results in the Preview area with sorting, filtering, and Find by email or phone." },
    { t: "Enrich websites", d: "Fetch emails from websites. Dedupe and score trust as rows fill in." },
    { t: "Filter & focus", d: "Filter by email, phone, trust, form status, or template. Drop the weak rows." },
    { t: "Open contact routes", d: "Open contact pages with the form helper, or compose in the Rich Email Editor." },
    { t: "Test before bulk", d: "Test-email-first puts your own address at the top of the list. Inspect, then continue." },
    { t: "Send through your SMTP", d: "Ship from Google Workspace, Resend, or any provider you control — with quota guard." },
    { t: "Phone & WhatsApp follow-up", d: "Push mobiles to WhatsApp Web/Desktop with templated messages and pacing." },
    { t: "Log every outcome", d: "Form, email, manual, and WhatsApp outcomes stamp the per-business activity timeline." },
    { t: "Keep opt-outs clean", d: "Suppression lists + Cloudflare-handled unsubscribe make every future send safer." },
];

export default function Workflow() {
    return (
        <section
            id="workflow"
            data-testid="workflow-section"
            className="border-b border-border bg-bg"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-4 lg:sticky lg:top-24">
                        <span className="overline">Typical workflow</span>
                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mt-4 leading-[1.05] text-ink">
                            Ten steps from a market idea to a logged reply.
                        </h2>
                        <p className="mt-6 text-ink-soft max-w-md">
                            ReachForge isn't a black box. Every step is
                            inspectable — your data, your provider, your
                            decisions. The app just removes the drudgery
                            between them.
                        </p>
                    </div>

                    <ol className="lg:col-span-8 border-t border-border">
                        {steps.map((s, i) => (
                            <li
                                key={s.t}
                                data-testid={`workflow-step-${i + 1}`}
                                className="grid grid-cols-[64px_1fr] sm:grid-cols-[96px_1fr] gap-6 py-6 border-b border-border group"
                            >
                                <div className="font-display text-3xl sm:text-4xl font-black tracking-tighter text-ink-mute group-hover:text-forge transition-colors">
                                    {String(i + 1).padStart(2, "0")}
                                </div>
                                <div>
                                    <div className="font-display text-lg sm:text-xl font-semibold text-ink">
                                        {s.t}
                                    </div>
                                    <p className="mt-1 text-ink-soft text-sm sm:text-base leading-relaxed">
                                        {s.d}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
